import ShortKey from "vue3-shortkey";

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.use(ShortKey, { prevent: ["input", "textarea", "default"] });
});
